type DiopterColorType =
  | "diopter-250"
  | "diopter-225"
  | "diopter-200"
  | "diopter-175"
  | "diopter-150"
  | "diopter-125";

type planoType = "icu" | "wink";

const planoDiopters: Record<planoType, DiopterColorType[]> = {
  icu: ["diopter-250", "diopter-225", "diopter-200", "diopter-175", "diopter-150", "diopter-125"],
  wink: ["diopter-250", "diopter-200", "diopter-150", "diopter-125"],
};

export function getDiopterClassname(idx: number, planoType: planoType): DiopterColorType {
  const diopters = planoDiopters[planoType];

  return diopters[idx % diopters.length];
}

export function getIcuLeftPanelUpcs() {
  return [
    "078041227632",
    "078041227625",
    "078041227618",
    "078041227601",
    "078041227595",
    "078041227588",

    "078041227564",
    "078041227557",
    "078041227540",
    "078041227533",
    "078041227526",
    "078041227519",

    "078041228189",
    "078041228172",
    "078041228165",
    "078041228158",
    "078041228141",
    "078041228134",

    "078041227694",
    "078041227717",
    "078041227687",
    "078041227670",
    "078041227663",
    "078041227656",
  ];
}

export function getIcuFrontPanelUpcs() {
  return [
    "078041129158",
    "078041129141",
    "078041129134",
    "078041129127",
    "078041129110",
    "078041129103",

    "078041140771",
    "078041140764",
    "078041140757",
    "078041140740",
    "078041140733",
    "078041140726",

    "078041196907",
    "078041196891",
    "078041196884",
    "078041196877",
    "078041196860",
    "078041196853",

    "078041050995",
    "078041073437",
    "078041050988",
    "078041050971",
    "078041050964",
    "078041050957",

    "078041140702",
    "078041140696",
    "078041140689",
    "078041140672",
    "078041140665",
    "078041140658",

    "078041196839",
    "078041196822",
    "078041196815",
    "078041196808",
    "078041196792",
    "078041196785",

    "078041143932",
    "078041143925",
    "078041143918",
    "078041143901",
    "078041143895",
    "078041143888",

    "078041143826",
    "078041143819",
    "078041143802",
    "078041143796",
    "078041143789",
    "078041143772",

    "078041128946",
    "078041128939",
    "078041128922",
    "078041128915",
    "078041128908",
    "078041128892",
  ];
}

export function getIcuRightPanelUpcs() {
  return [
    "078041210016",
    "078041210009",
    "078041209997",
    "078041209980",
    "078041209973",
    "078041209966",

    "078041209942",
    "078041209935",
    "078041209928",
    "078041209911",
    "078041209904",
    "078041209898",

    "078041210160",
    "078041210153",
    "078041210139",
    "078041210122",
    "078041210115",
    "078041210108",

    "078041210085",
    "078041210078",
    "078041210061",
    "078041210054",
    "078041210047",
    "078041210030",
  ];
}

export function getWinkPanelUpcs() {
  return [
    "078041189916",
    "078041189909",
    "078041189893",
    "078041189886",

    "078041143246",
    "078041143239",
    "078041143222",
    "078041143215",

    "078041138457",
    "078041138440",
    "078041138433",
    "078041138426",

    "078041131861",
    "078041131854",
    "078041131847",
    "078041131830",

    "078041132141",
    "078041132134",
    "078041132127",
    "078041132110",
  ];
}
